module.exports = __webpack_public_path__ + "media/images/flags/BG-23c4d4ffbcc1e000cd5d7539e6feb963.svg";